import React, { useEffect } from "react";

const LimitReachedOverlay = ({
  open,
  title = "Limit Reached",
  message = "",
  primaryLabel = "Upgrade Plan",
  onPrimary,
  secondaryLabel = "Cancel",
  onSecondary,
}) => {

  // Lock global scroll while overlay is open (mobile + desktop).
  // 🔒 Lock background scroll
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="absolute inset-0 z-40 bg-white/70 backdrop-blur-sm flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={(e) => {
        // Prevent accidental dismiss on backdrop unless explicitly wired.
        e.stopPropagation();
      }}
    >
      <div
        className="w-full max-w-xl overflow-auto bg-white rounded-2xl shadow-2xl border border-gray-100 px-6 py-8"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="lg:text-2xl text-lg font-bold text-center text-gray-900 mb-3">
          {title}
        </h2>

        {message ? (
          <p className="lg:text-base text-sm text-center text-gray-600 mb-8 leading-relaxed">
            {message}
          </p>
        ) : null}

        <div className="flex flex-col items-center gap-3">
          <button
            type="button"
            onClick={onPrimary}
            className="w-full max-w-sm bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2.5 lg:py-3 text-sm lg:text-base rounded-xl shadow"
          >
            {primaryLabel}
          </button>

          {secondaryLabel ? (
            <button
              type="button"
              onClick={onSecondary}
              className="text-gray-500 hover:text-gray-700 text-sm lg:text-base underline underline-offset-2"
            >
              {secondaryLabel}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default LimitReachedOverlay;

